export default "__VITE_ASSET__BRdFOsnu__"